// Fichier: src/pages/Accounting.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Grid, Card, CardActionArea, CardContent, Avatar } from '@mui/material';
import {
  AccountBalance as AccountBalanceIcon,
  MenuBook as MenuBookIcon,
  Assessment as AssessmentIcon,
  Balance as BalanceIcon,
  ListAlt as ListAltIcon,
  Bolt as BoltIcon
} from '@mui/icons-material';

const TILES = [
  {
    title: 'Saisie rapide',
    description: "Enregistrer une opération courante en 2 clics",
    icon: <BoltIcon />,
    path: '/accounting/quick-entry',
    color: '#F97316'
  },
  {
    title: 'Plan comptable',
    description: 'Gérer les comptes (PCMN ASBL)',
    icon: <AccountBalanceIcon />,
    path: '/accounting/chart-of-accounts',
    color: '#7C3AED'
  },
  {
    title: 'Livre journal',
    description: 'Saisir et consulter les écritures',
    icon: <MenuBookIcon />,
    path: '/accounting/journal',
    color: '#0EA5E9'
  },
  {
    title: 'Grand livre',
    description: 'Soldes des comptes et détail par compte',
    icon: <ListAltIcon />,
    path: '/accounting/ledger',
    color: '#6366F1'
  },
  {
    title: 'Bilan',
    description: "Actif, passif et fonds sociaux",
    icon: <BalanceIcon />,
    path: '/accounting/balance-sheet',
    color: '#10B981'
  },
  {
    title: 'Compte de résultats',
    description: "Charges et produits de l'exercice",
    icon: <AssessmentIcon />,
    path: '/accounting/income-statement',
    color: '#F59E0B'
  }
];

const Accounting = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1 }}>Comptabilité</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        Comptabilité en partie double — plan comptable minimum normalisé pour ASBL
      </Typography>

      <Grid container spacing={3}>
        {TILES.map((tile) => (
          <Grid item xs={12} sm={6} md={3} key={tile.path}>
            <Card sx={{ height: '100%', opacity: tile.disabled ? 0.5 : 1, borderRadius: '12px' }}>
              <CardActionArea
                disabled={tile.disabled}
                onClick={() => navigate(tile.path)}
                sx={{ height: '100%', p: 1 }}
              >
                <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
                  <Avatar sx={{ bgcolor: tile.color, width: 48, height: 48 }}>{tile.icon}</Avatar>
                  <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{tile.title}</Typography>
                  <Typography variant="body2" color="text.secondary">{tile.description}</Typography>
                  {tile.disabled && (
                    <Typography variant="caption" color="text.secondary">Bientôt disponible</Typography>
                  )}
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Accounting;